import { render, staticRenderFns } from "./PortfolioCarousel.vue?vue&type=template&id=096f9e34&scoped=true&"
import script from "./PortfolioCarousel.vue?vue&type=script&lang=js&"
export * from "./PortfolioCarousel.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioCarousel.vue?vue&type=style&index=0&id=096f9e34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096f9e34",
  null
  
)

export default component.exports